<div class="presets mat-elevation-z3" fxFlex fxLayout="column" fxLayoutAlign="start stretch">
  <button
    (click)="selectPreset(item.range)"
    *ngFor="let item of presets"
    color="transparent"
    mat-flat-button
  >
    {{ item.label }}
  </button>
</div>
<fury-calendar-header></fury-calendar-header>
